import { render, staticRenderFns } from "./StockLevel.vue?vue&type=template&id=97286ab6&scoped=true&"
import script from "./StockLevel.vue?vue&type=script&lang=js&"
export * from "./StockLevel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97286ab6",
  null
  
)

export default component.exports